<mat-card fxFlex="50%" class="mat-elevation-z0 p-3" *ngIf="showMap">
	<div fxFill>
		<div
			leaflet
			[leafletOptions]="baseOptions"
			[leafletCenter]="mapCenter"
			[leafletZoom]="zoom"
			id="job-map"
		>
			<div [leafletLayer]="marker"></div>
		</div>
	</div>
</mat-card>
<mat-card class="mat-elevation-z0 p-0" *ngIf="job">
	<h1 mat-dialog-title>{{ job.number }} &mdash; {{ job.description }}</h1>
	<p class="mb-1 mt-0">{{ job.customer.name }}</p>
	<p class="mb-1 mt-0">
		{{ job.fieldContacts[0] | fullName: 'No field contact yet' }}
	</p>
	<p class="mb-1 mt-0">{{ job.location }}</p>
	<p class="mb-1 mt-0">
		<strong
			>{{ job.start | date: 'MM/dd/yy':'utc' }} -
			{{ job.end | date: 'MM/dd/yy':'utc' }}</strong
		>
	</p>
	<mat-list-item class="needs-attention">
		<p
			matLine
			[matBadge]="job.unassignedShifts.length"
			matBadgePosition="before"
			matBadgeSize="medium"
			matBadgeColor="warn"
			matBadgeOverlap="false"
		>
			Scheduling days need attention
		</p>
		<!-- <p *ngIf="isContext('missingDWR')" matLine [matBadge]="job.missingDwrs" matBadgePosition="before" matBadgeSize="medium" matBadgeColor="warn" matBadgeOverlap="false">Scheduling days need attention</p> -->
	</mat-list-item>
</mat-card>
